import {Injectable} from "@angular/core";
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {catchError, map} from "rxjs/operators";
import {BaseService} from "@shared/services/base.service";
import {User} from "@shared/models/user";
import {PagedResult} from "@shared/models/paged-result";
import {Injector} from "@angular/core";

@Injectable()
export class UsersService extends BaseService {
    constructor(private readonly _httpClient: HttpClient, protected readonly injector: Injector) {
        super(injector);
    }

    /**
     * Returns a collection of Users by the given parameters
     * @param roleName Role Name
     * @param sorting Sorting
     * @param maxResultCount Max Results returned
     * @param skipCount Skip Number of Results
     * @constructor
     */
    getUsers(roleName: string, sorting: string, maxResultCount: number, skipCount: number): Observable<PagedResult<User>> {
        let url = this.environment.backendUrl + '/api/services/app/Users/v2/GetUsers';
        url = url.replace(/[?&]$/, "");

        let params = new HttpParams();

        params = params.appendAll({
            "roleName": roleName,
            "sorting": sorting,
            "maxResultCount": maxResultCount,
            "skipCount": skipCount
        });

        return this._httpClient
            .get<any>(url, {params: params})
            .pipe(
                map((response: any) => {
                    return response.result as PagedResult<User> ?? null;
                }),
                catchError(this.handleError),
            );
    }

    /**
     * Returns a User by the given Id
     * @param id User Id
     */
    getUser(id: number): Observable<User> {
        let url = this.environment.backendUrl + '/api/services/app/Users/v2/GetUser';
        url = url.replace(/[?&]$/, "");

        let params = new HttpParams();

        params = params.appendAll({
            "id": id
        });

        return this._httpClient
            .get<any>(url, {params: params})
            .pipe(
                map((response: any) => {
                    return response.result as User ?? null;
                }),
                catchError(this.handleError),
            );
    }
}
